"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialInvalidLifetimeError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "CredentialInvalidLifetime";
const messageKey = "driver.aadApp.error.credentialInvalidLifetimeAsPerAppPolicy";
class CredentialInvalidLifetimeError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey),
            helpLink: constants_1.constants.defaultHelpLink,
        });
    }
}
exports.CredentialInvalidLifetimeError = CredentialInvalidLifetimeError;
//# sourceMappingURL=credentialInvalidLifetimeError.js.map